var React = require('react');

function Github (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#000","fillRule":"nonzero","d":"M12 3a9.112 9.112 0 0 0-9 9.224A9.202 9.202 0 0 0 9.155 21c.45.078.619-.192.619-.44v-1.72c-2.25.427-2.846-.563-3.026-1.125a3.375 3.375 0 0 0-.923-1.305c-.315-.169-.765-.596 0-.608a1.8 1.8 0 0 1 1.384.945 1.901 1.901 0 0 0 2.542.788c.037-.468.24-.907.574-1.238-2.002-.236-4.095-1.023-4.095-4.5a3.645 3.645 0 0 1 .923-2.474 3.375 3.375 0 0 1 .09-2.441s.753-.248 2.474.945a8.28 8.28 0 0 1 4.5 0c1.721-1.204 2.475-.945 2.475-.945.334.774.366 1.645.09 2.441.608.68.937 1.563.922 2.475 0 3.543-2.103 4.32-4.106 4.5a2.25 2.25 0 0 1 .653 1.71v2.542s.169.528.619.438a9.224 9.224 0 0 0 6.13-8.763A9.112 9.112 0 0 0 12 3z"}));
}

Github.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = Github;

Github.default = Github;
